import React from 'react'
import Swal from 'sweetalert2';
import { Link } from "react-router-dom";
import authAxios from "../../services/Token";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDollarSign, faEdit, faTimes } from '@fortawesome/free-solid-svg-icons';

class Editar extends React.Component {
    constructor(props) {
        super(props);
    }
    state = {
        load: '',
        datosCargados: false,
        arrayResultado: [],
        errores: []
    }
    cambioValor = (e) => {
        const state = this.state.arrayResultado;
        state[e.target.name] = e.target.value;
        this.setState({ arrayResultado: state });
    };
    verificarError(elemento) {
        return this.state.errores.indexOf(elemento) !== -1;
    }
    enviarDatos = (e) => {
        e.preventDefault();
        const nombre = document.getElementById('nombre').value;
        const ID_TIPO_EQUIPO = document.getElementById('ID_TIPO_EQUIPO').value;
        const tarifa_dia = document.getElementById('tarifa_dia').value;
        const valor = document.getElementById('valor').value;
        var errores = [];
        if (!nombre) { errores.push("error_nombre"); }
        if (!ID_TIPO_EQUIPO) { errores.push("error_id_tipo_equipo"); }
        if (!tarifa_dia) { errores.push("error_tarifa_dia"); }
        if (!valor) { errores.push("error_valor"); }
        let form = document.getElementById('form');
        let formData = new FormData(form);
        console.log(errores.length);
        this.setState({ errores: errores });
        if (errores.length > 0) {
            return false;
        }
        Swal.showLoading();
        authAxios.post("equipos/editar", formData)
            .then((datosRespuesta) => {
                console.log(datosRespuesta)
                Swal.close();
                Swal.fire(
                    'Equipos!',
                    datosRespuesta.data.msj,
                    'success'
                )
                this.props.history.push("/MasterEquipos");
            })
            .catch(console.log)
    }
    componentDidMount() {
        Swal.showLoading();
        authAxios.get("equipos/ver/" + this.props.match.params.id)
            .then((datosRespuesta) => {
                console.log(datosRespuesta);
                this.setState({ datosCargados: true, arrayResultado: datosRespuesta.data, load: '' });
                Swal.close();
            })
            .catch(console.log);
    }
    render() {
        const { load, arrayResultado } = this.state;
        return (
            <div className="content-wrapper">
                <div className="content">
                    <div className="container-fluid">
                        <br />
                        <div className="card">
                            <div className="card-header text-center">
                                {load ? (<b>{load}</b>) : (<b>EDITAR EQUIPO</b>)}
                            </div>
                            <div className="card-body">
                                <form onSubmit={this.enviarDatos} id="form">
                                    <div className='row'>
                                        <div className="col-xl-12">
                                            <div className='row g-3'>
                                                <div className="col-md-6">
                                                    <label htmlFor="nombre">Nombre</label>
                                                    <input type="hidden" name="id" value={this.props.match.params.id} />
                                                    <input style={{ textTransform: 'uppercase' }} type="text" name="nombre" id="nombre" defaultValue={arrayResultado.NOMBRE}
                                                        className={((this.verificarError("error_nombre")) ? "is-invalid" : "") + " form-control form-control-sm"} placeholder="Nombre" aria-describedby="helpId"
                                                        onChange={this.cambioValor}
                                                    />
                                                </div>
                                                <div className="col-md-2">
                                                    <label htmlFor="ID_TIPO_EQUIPO">Equipo</label>
                                                    <select name="ID_TIPO_EQUIPO"
                                                        id="ID_TIPO_EQUIPO"
                                                        value={arrayResultado.ID_TIPO_EQUIPO}
                                                        options={arrayResultado.ID_TIPO_EQUIPO}
                                                        className={((this.verificarError("error_id_tipo_equipo")) ? "is-invalid" : "") + " form-select form-select-sm"}
                                                        onChange={this.cambioValor}>
                                                        <option value="">Seleccione el Tipo</option>
                                                        <option value="1">Eléctrico (ELEC)</option>
                                                        <option value="2">Equipo (EQU)</option>
                                                        <option value="3">Seguridad (SEG)</option>
                                                        <option value="4">Transporte (TR)</option>
                                                    </select>
                                                    <small id="helpId" className="invalid-feedback">Seleccione el Tipo</small>
                                                </div>
                                                <div className="col-md-2">
                                                    <label htmlFor="tarifa_dia">Tarifa / Día</label>
                                                    <div className="input-group input-group-sm">
                                                        <span className="input-group-text" id="inputGroupPrepend"><FontAwesomeIcon icon={faDollarSign} /></span>
                                                        <input style={{ textTransform: 'uppercase' }} type="text" name="tarifa_dia" id="tarifa_dia" defaultValue={arrayResultado.TARIFA_DIA}
                                                            className={((this.verificarError("error_tarifa_dia")) ? "is-invalid" : "") + " form-control form-control-sm"} placeholder="Tarifa / Día" aria-describedby="helpId"
                                                            onChange={this.cambioValor}
                                                        />
                                                    </div>
                                                    <small id="helpId" className="invalid-feedback">Digite la Tarifa / Día</small>
                                                </div>
                                                <div className="col-md-2">
                                                    <label htmlFor="valor">Valor</label>
                                                    <div className="input-group input-group-sm">
                                                        <span className="input-group-text" id="inputGroupPrepend"><FontAwesomeIcon icon={faDollarSign} /></span>
                                                        <input style={{ textTransform: 'uppercase' }} type="text" name="valor" id="valor" defaultValue={arrayResultado.VALOR}
                                                            className={((this.verificarError("error_valor")) ? "is-invalid" : "") + " form-control form-control-sm"} placeholder="Valor" aria-describedby="helpId"
                                                            onChange={this.cambioValor}
                                                        />
                                                    </div>
                                                    <small id="helpId" className="invalid-feedback">Digite el Valor</small>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <hr />
                                    <div className='row'>
                                        <div className='col-xl-12 text-center'>
                                            <div className="btn-group" role="group" aria-label="">
                                                <button type="submit" className="btn btn-primary btn-sm"><FontAwesomeIcon icon={faEdit} />&nbsp;&nbsp;Editar Equipo</button>&nbsp;&nbsp;
                                                <Link className="btn btn-danger btn-sm" to={"/MasterEquipos"}><FontAwesomeIcon icon={faTimes} />&nbsp;&nbsp;Cancelar</Link>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default Editar;